import { NewEntityId } from "../../data/constants";
import { LocationViewModel } from "../../model/LocationViewModel";

export const initialLocation: LocationViewModel = {
  id: NewEntityId,
  name: "",
  canton: "",
  city: "",
  contactEmailAddress: "",
  contactName: "",
  contactPhoneNo: "",
  languageRegions: [],
  linkToMap: "",
  rooms: [],
  street: "",
  zipCode: "",
};
